import React from 'react';
import cx from 'classnames';

import ContainerEdit from '@plone/volto/components/manage/Blocks/Container/Edit';

import { BG_CONTAINER_COLORS } from '../../colors';
import './BGContainer.scss';

const BGContainerEdit = (props) => {
  const { data = {}, className, style } = props;
  const bgVar = style?.['--backgroundColor--background-color'];
  const selectedColor = BG_CONTAINER_COLORS.find(
    (item) => item.style['--background-color'] === bgVar,
  );

  return (
    <div
      className={cx(
        'block',
        className,
        'bg-content-wrapper',
        data.fullWidth && 'bg-content-wrapper-fullwidth',
        selectedColor?.name && `bg-content-wrapper-${selectedColor.name}`,
      )}
      style={style}
    >

      <div className="bg-content-wrapper-inner ui container">
        <ContainerEdit {...props} direction="vertical" />
      </div>

    </div>
  );
};

export default BGContainerEdit;